class DeviceDetailsCtrl  
  @$inject: ["$rootScope", "$scope", "$stateParams", "$state", "toasty", "socket", "warning", "firewallTest", "editor", "selector", "pusher", "configurator", "Device"]  
  constructor: ($rootScope, $scope, $stateParams, $state, toasty, socket, warning,firewallTest, editor, selector, pusher, configurator, Device)->                
    
    $scope.reboot = (device)->      
      options = 
        title: "Reboot Device"
        msg: "Confirm to reboot device?"
      warning.warn(options)
        .then ()->
          $scope.device.$reboot()
        .then ()->
          $scope.refreshLog device
    $scope.logcat = (device)->
      device.$logcat()
    $scope.firewall = (device)->
      options = 
        title: "Firewall Test"
        device: device
        backdrop: true
      firewallTest.open(options)

    $scope.refresh = ()->
      Device.get({_id: $stateParams._id}).$promise.then (result)=>
        $scope.device = result      
        opts = 
          device: $scope.device._id
        $scope.refreshLog $scope.device
        $scope.device.$details()
      .then (details)->
        $scope.details = details
        $scope.logFilter = device: $scope.device._id
      .then ()->
        $scope.device.$support()
      .then (support)->
        $scope.support = support
      .catch (err)->
        console.error err
      
    $scope.install = (device)->
      options = 
        model: "Resource"
      if device.os is "ANDROID"
        options.filter = 
          type: ["FOLDER", "APK"]
      else
        options.filter = 
          type: ["FOLDER", "CPK"]
      selector.select(options).then (resource)->
        device.$install(resource)
      .then ()->   
        $scope.refreshLog $scope.device    
        toasty.success
          title: 'Install Pending'
          msg: "Check the Audit Log for install status"
      .catch (err)->
        if err is "escape key press" or err is "backdrop click" or err is "cancelled"
          return
        toasty.error
          title: 'Install App Error'
          msg: "Please refresh the secret token and try again"
    $scope.ota = (device)->
      options = 
        model: "Resource"
        filter:
          type: ["FOLDER", "OTA"]      
      selector.select(options).then (resource)->
        device.$ota(resource)
      .then ()->      
        $scope.refreshLog device  
        toasty.success
          title: 'OTA Pending'
          msg: "Check the Audit Log for OTA status"
      .catch (err)->
        if err is "escape key press" or err is "backdrop click" or err is "cancelled"
          return
        toasty.error
          title: 'OTA Error'
          msg: "Please refresh the secret token and try again"

    $scope.remote = (device)->
      opt = 
        _id: device._id
      $state.go("device-remote", opt)

      
    $scope.pull = (device)->
      options = 
        source:
          path: null
        schema:
          path:
            type: "String"
            display: "Resource Path"
            required: true
      editor.edit(options).then (result)->
        device.$pull(result.path)
    $scope.secret = (device)->
      device.$secret().then ()->    
        $scope.refreshLog device        
        toasty.success
          title: 'Refresh Secret Success'
          msg: "Refresh Secret of #{device.name} success"  
    $scope.edit = (device)->
      dirty = angular.copy(device)
      options = 
        source: dirty
        schema:
          name:
            type: "String"
            display: "Device Name"            
          description:
            type: "Text"
            display: "Description"
      if $rootScope.user.company.type is "ADMIN"
        schema = options.schema
        schema["order"] =
          type: "String"
          display: "Order No."
        schema["serialno"] =
          type: "String"
          display: "Serial No."   
         schema["shipping"] =
            shippedAt:
              type: "Date"
              display: "Shipping Date"       

      editor.edit(options).then (result)->        
        result.$save()
      .then (result)->
        angular.copy(result, device)
        toasty.success
          title: 'Save Success'
          msg: "Save device information success"
    $scope.timezone = (device)->
      dirty = angular.copy(device)
      options = 
        source: dirty
        schema:
          timezone:
            type: "TimeZone"
            display: "TimeZone"
      editor.edit(options)
      .then (result)->
        angular.copy(result,device)        
        device.$timezone(device.timezone)
      .then ()->
        $scope.refreshLog device
        $scope.details.timezone=device.timezone
        toasty.success
          title: 'Save Success'
          msg: "Save timezone success"
      .catch (err)->
        toasty.error
          title: "Device Offline"
          msg: "Set timezone fail"
    $scope.assign = (device)->
      opts = 
        model: "Company"
        fields:[
          {value: "name", display: "Name"}
        ]

      selector.select(opts)
      
    $scope.push = (device)->      
      pusher.push().then (res)->
        device.$push res.resource, res.path
      .then ()->
        $scope.refreshLog device
        toasty.success
          title: 'Push Resource'
          msg: "Check the Audio Log for download resource status"      
      .catch (err)->
        if err is "escape key press" or err is "backdrop click" or err is "cancelled"
          return
        toasty.error
          title: 'Install App Error'
          msg: "Please refresh the secret token and try again"


    $scope.restartApp = (device, app)->
      device.$restart(app.packageName).then ()->
        $scope.refreshLog device
        toasty.success
          title: 'Restart App Success'
          msg: "Restart app #{app.name} success"

    $scope.moveApp = (device, app)->
      device.$move(app.packageName).then ()->
        $scope.refreshLog device
        toasty.success
          title: 'Move App Success'
          msg: "Move app #{app.name} success"
        options = 
          title: "Reboot Device"
          msg: "Reboot the device to sync the change?"
        warning.warn(options)
      .then ()->
        $scope.device.$reboot()
    $scope.configApp = (device, app)->
      configurator.config(device, app).then ()->
        $scope.refreshLog device
        toasty.success
          title: 'Edit Pref Success'
          msg: "Edit Pref Successfully"
      .catch (err)->
        if err is "escape key press" or err is "backdrop click" or err is "cancelled"
          return
        toasty.warning
          title: 'Edit Pref Not Supported'
          msg: "App not support ot edit the pref"

    $scope.uninstallApp = (device, app)->
      device.$uninstall(app.packageName).then ()->
        $scope.refreshLog device
        toasty.success
          title: 'Uninstall App Success'
          msg: "Uninstall app #{app.name} success"
    $scope.refreshLog = (device)->
      opts = 
        device: device._id
      $scope.$broadcast "operation-logs.filter", opts

    $scope.refresh()
    socket.removeListener "log report"
    socket.emit "listen device progress", $stateParams._id
    socket.on "log report", (evt)->
      $scope.refreshLog($scope.device)

module.exports = DeviceDetailsCtrl




// WEBPACK FOOTER //
// ./src/component/device/details/controller.coffee